import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background"></div>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="title-subtitle">Premium Cocopeat & Coir Products</span>
          </h1>
          <p className="hero-description">
            Leading manufacturer and supplier of high-quality cocopeat, coir fiber, and 
            agricultural products from Thane, India. Sustainable solutions for modern agriculture.
          </p>
          <div className="hero-buttons">
            <Link to="/products" className="btn btn-primary">
              Explore Products
            </Link>
            <Link to="/contact" className="btn btn-secondary">
              Get in Touch
            </Link>
          </div>
        </div>
        <div className="hero-scroll">
          <span>Scroll Down</span>
          <div className="scroll-arrow"></div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">About Soham Cocopeat</h2>
            <div className="title-underline"></div>
          </div>
          <div className="about-content">
            <div className="about-text">
              <p>
                Based in Thane, India, Soham Cocopeat is a trusted name in the cocopeat 
                and coir industry. We specialize in manufacturing and supplying premium quality 
                agricultural products derived from coconut husks.
              </p>
              <p>
                Our commitment to sustainability and quality has made us a preferred choice 
                for farmers, horticulturists, and agricultural businesses across India and beyond.
              </p>
              <div className="about-features">
                <div className="feature-item" style={{backgroundImage: "url('/background/Eco-Friendly.jpg')"}}>
                  <div className="feature-overlay"></div>
                  <div className="feature-content">
                    <div className="feature-icon">🌱</div>
                    <h3>Eco-Friendly</h3>
                    <p>100% natural and biodegradable products</p>
                  </div>
                </div>
                <div className="feature-item" style={{backgroundImage: "url('/background/Premium Quality.JPG')"}}>
                  <div className="feature-overlay"></div>
                  <div className="feature-content">
                    <div className="feature-icon">⭐</div>
                    <h3>Premium Quality</h3>
                    <p>Rigorous quality control standards</p>
                  </div>
                </div>
                <div className="feature-item" style={{backgroundImage: "url('/background/Reliable Supply.jpg')"}}>
                  <div className="feature-overlay"></div>
                  <div className="feature-content">
                    <div className="feature-icon">🚚</div>
                    <h3>Reliable Supply</h3>
                    <p>Consistent and timely delivery</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Preview */}
      <section className="products-preview">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Products</h2>
            <div className="title-underline"></div>
            <p className="section-description">
              Discover our wide range of cocopeat and coir products
            </p>
          </div>
          <div className="preview-grid">
            <div className="preview-card" style={{backgroundImage: "url('/background/Raw Materials.jpg')"}}>
              <div className="preview-overlay"></div>
              <div className="preview-content">
                <div className="preview-icon">🌿</div>
                <h3>Raw Materials</h3>
                <p>Coconut husk, raw fiber, cocopeat blocks, and more</p>
              </div>
            </div>
            <div className="preview-card" style={{backgroundImage: "url('/background/Finished Products.jpg')"}}>
              <div className="preview-overlay"></div>
              <div className="preview-content">
                <div className="preview-icon">📦</div>
                <h3>Finished Products</h3>
                <p>Coir ropes, pole sticks, and ready-to-use products</p>
              </div>
            </div>
            <div className="preview-card" style={{backgroundImage: "url('/background/Machinery.jpeg')"}}>
              <div className="preview-overlay"></div>
              <div className="preview-content">
                <div className="preview-icon">⚙️</div>
                <h3>Machinery</h3>
                <p>Processing equipment for coir and cocopeat</p>
              </div>
            </div>
          </div>
          <div className="preview-cta">
            <Link to="/products" className="btn btn-primary">
              View All Products
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;

